import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 48 48",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M22.5 2.5c11.03 0 20 8.97 20 20s-8.97 20-20 20-20-8.97-20-20 8.97-20 20-20m0-2.5C10.07 0 0 10.07 0 22.5S10.07 45 22.5 45 45 34.93 45 22.5 34.93 0 22.5 0z"
	}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M21.12 20.87l2.76.71V34.2h-2.76V20.87m-2.5-3.23V36.7h7.76V19.64l-7.76-2z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M23.88 10.8v2.78l-2.76-.71V10.8h2.76m2.5-2.5h-7.76v6.51l7.76 2V8.3z"
	})] })]
});
export default SvgIcon;
